import CustomModal, { ModalHeader, ModalBody, ModalFooter } from '@/components/shared/CustomModal'

const RunsheetTabRemoveModal = ({ show, onClose, onDelete, tabs, tabId }) => {
    
    const currentTab = tabs.find(t => t.id === tabId)
    
    const handleDelete = () => {
        onDelete(currentTab)
        onClose()
    }
    
    return (
        <CustomModal open={show} modalHandler={onClose}>
            <ModalHeader>Delete Tab</ModalHeader>
            <ModalBody>
                <p>Are you sure you want to delete <span className="underline">{currentTab?.name}</span> ?</p>
                <p className="text-sm text-neutral mt-4">
                    Note: This will not delete the documents from the main Runsheet.
                </p>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-primary btn-outline" onClick={onClose}>Cancel</button>
                <button className="btn btn-primary" onClick={handleDelete}>Delete</button>
            </ModalFooter>
        </CustomModal>
    )
}

export default RunsheetTabRemoveModal